<!-- 左栏 “自然资源局分局、县区局” 列表组件 -->

<template>
    <div class="list-box">
        <ul class="list">

            <li v-for=" list in res_list" :key="list.attributes.OBJECTID">
                <!--  详见<list_card>组件  -->
                <list_card 
                    :Name="list.attributes.Name" 
                    :Address="list.attributes.Address" 
                    :Tel="list.attributes.Tel"
                    :OBJECTID="list.attributes.OBJECTID" >
                </list_card>
            </li>

        </ul>
    </div>
</template>
  
<script>
  import left_zrzyjfj_list from "./left_zrzyjfj_list";
  export default left_zrzyjfj_list;
</script>
  

<style scoped>
@import '../styles/left_list.css';
</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-phone/left_zrzyjfj_list/left_zrzyjfj_list.vue